// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__qxZD6","author":"Table_author__A-qb6","authorImage":"Table_authorImage__36ZSa","unreadRow":"Table_unreadRow__I3fmq"};